import { Box, Button, Card, CardContent, Grid, IconButton, styled, useMediaQuery, FormControl, FormControlLabel, RadioGroup, Radio, Typography } from '@mui/material';
import Add from '@mui/icons-material/Add';
import Remove from '@mui/icons-material/Remove';
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { withSnackbar } from "../../../utils/SnackbarHOC";
import { theme } from "../../../utils/Theme";
import { getAllCandidatsForReporting } from "../../../services/CandidatService";
import { getMissionsActive } from "../../../services/MissionService";
import { getSocietesWithActiveMission } from "../../../services/SocieteService";
import ReportingInternList from "./components/reporting-intern-list";
import TableReportingIntern from "./components/table-reporting-intern";
import { getTalentManagers } from "../../../services/UserService";
import "./reporting.css";
import DownloadXLSFile from "../DownloadXLSFile";

const ReportingIntern = ({ snackbarShowMessage }) => {
    const history = useHistory();
    const useStyles = styled({
        archiveButton: {
            color: '#fff',
            fontWeight: 600,
            background: 'linear-gradient(135deg, #0556a4, #03407b)',
            borderRadius: '10px',
            textTransform: 'none',
            mb: 1,
            '&:hover': {
                background: 'linear-gradient(135deg, #03407b, #022d68)',
            }
        },
        fileDownloadIcon: {
            color: '#03407b'
        }
    })

    const classes = useStyles();
    const [reloadData, setReloadData] = useState(false);
    const location = useLocation();
    const [reportingData, setReportingData] = useState({
        isLoading: false,
        data: []
    });
    const showAllValue = { id: 1, value: "TOUTES" };

    const [clientData, setClientData] = useState({
        isLoading: false,
        data: [showAllValue],
        value: showAllValue,
        label: "RECHERCHER PAR CLIENT"
    });

    const [missionData, setMissionData] = useState({
        isLoading: false,
        data: [showAllValue],
        value: showAllValue,
        label: "RECHERCHER PAR MISSION DU CLIENT SÉLECTIONNÉ"
    });

    const [talentManagerData, setTalentManagerData] = useState({
        isLoading: false,
        data: [showAllValue],
        value: showAllValue,
        label: "RECHERCHER PAR TALENT MANAGER"
    });

    const [query, setQuery] = useState({
        inactive: false
    });

    const loadMissionData = () => {
        setMissionData((prevState) => ({
            ...prevState,
            isLoading: true,
            data: [],
            value: showAllValue
        }))
    }

    const loadReportingData = () => {
        setReportingData((prevState) => ({
            ...prevState,
            isLoading: true,
            data: []
        }))
    }


    const handleMissionActiveFromClientSelected = (newValue) => {
        const searchParams = new URLSearchParams();
        if (newValue.value !== 'TOUTES') {
            searchParams.append('societe', newValue.id);
        }
        const searchQuery = newValue.value !== 'TOUTES' ? `?${searchParams.toString()}` : '';
        loadMissionData();
        getMissionsActive(searchQuery)
            .then((response) => {
                setMissionData((prevState) => ({
                    ...prevState,
                    data: [showAllValue, ...response.data],
                    isLoading: false
                }));
            })
            .catch(() => {
                snackbarShowMessage("Erreur de chargement des missions.", "error", 4000);
                setMissionData((prevState) => ({
                    ...prevState,
                    data: [showAllValue],
                    isLoading: false
                }));
            });
    }

    const resetParamsUrl = () => {
        const params = new URLSearchParams();
        params.append('inactive', query.inactive);
        params.append('status', 'ACTIVE');
        return params
    }

    const getInitialParameters = () => {
        const searchParams = new URLSearchParams(location.search);
        if (searchParams.toString()) return searchParams.toString();
        return resetParamsUrl().toString();
    };

    const handleMissionChange = (newValue) => {
        const params = new URLSearchParams();
        const searchParams = new URLSearchParams(location.search);
        if (searchParams.get("societe")) {
            params.append('societe', searchParams.get("societe"));
            params.append('client', searchParams.get("client"));
        }
        params.append('inactive', query.inactive);
        params.append('status', 'ACTIVE');
        if (newValue.value == 'TOUTES') {
            history.push(`/reporting/intern?${params.toString()}`);
            return
        }
        params.append('mission', newValue.id);
        params.append('missiondata', JSON.stringify(newValue));
        history.push(`/reporting/intern?${params.toString()}`);
    }
    const [selectedClient, setSelectedClient] = useState("");

    const handleClientChange = (newValue) => {
        setSelectedClient(newValue.value);

        if (newValue.value == 'TOUTES') {
            history.push(`/reporting/intern`);
            handleMissionActiveFromClientSelected({ id: 1, value: 'TOUTES' });
            return
        }
        const params = new URLSearchParams();
        params.append('societe', newValue.id);
        params.append('client', JSON.stringify(newValue));
        params.append('inactive', query.inactive);
        params.append('status', 'ACTIVE');
        history.push(`/reporting/intern?${params.toString()}`);
        handleMissionActiveFromClientSelected(newValue)
    };

    const handleTalentManagerChange = (newValue) => {
        
        const params = new URLSearchParams();
        const searchParams = new URLSearchParams(location.search);
        if (searchParams.get("societe")) {
            params.append('societe', searchParams.get("societe"));
            params.append('client', searchParams.get("client"));
        }
        if (searchParams.get("mission")) {
            params.append('mission', searchParams.get("mission"));
            params.append('missionData', searchParams.get("missionData"));
        }
        
        if (newValue.value === 'TOUTES') {
            history.push(`/reporting/intern?${params.toString()}`);
            return
        }
        params.append('inactive', query.inactive);
        params.append('status', 'ACTIVE');
        params.append('talentManager', newValue.id);
        params.append('talentManagerData', JSON.stringify(newValue));
        history.push(`/reporting/intern?${params.toString()}`);
        handleMissionActiveFromClientSelected(newValue)
    }


    useEffect(() => {
        const fetchData = async () => {
            try {
                const searchParams = new URLSearchParams(location.search);
                const clientSelected = JSON.parse(searchParams.get("client"));
                clientSelected != null && searchParams.append('societe', clientSelected.id);
                const searchQuery = clientSelected != null ? `?${searchParams.toString()}` : ''
                const [clientResponse, missionResponse, talentManagerResponse] = await Promise.all([
                    getSocietesWithActiveMission(),
                    getMissionsActive(searchQuery),
                    getTalentManagers("?role=ROLE_TALENT_MANAGER")
                ]);

                setClientData((prevState) => ({
                    ...prevState,
                    data: [showAllValue, ...clientResponse.data],
                    isLoading: false
                }));
                setTalentManagerData((prevState) => ({
                    ...prevState,
                    data: [showAllValue, ...talentManagerResponse.data.map(item => ({ id: item.uuid, value: item.user }))]
                }))
                setFilteredClients([showAllValue, ...clientResponse.data]);

                setMissionData((prevState) => ({
                    ...prevState,
                    data: [showAllValue, ...missionResponse.data],
                    isLoading: false
                }));
            } catch (error) {
                snackbarShowMessage("Erreur de chargement des données.", "error", 4000);
                setClientData((prevState) => ({
                    ...prevState,
                    data: [showAllValue],
                    isLoading: false
                }));
                setMissionData((prevState) => ({
                    ...prevState,
                    data: [showAllValue],
                    isLoading: false
                }));
                setTalentManagerData((prevState) => ({
                    ...prevState,
                    data: [showAllValue],
                    isLoading: false
                }));
            }
        };

        fetchData();
    }, []);


    const fetchReportingData = async () => {
        const searchParams = new URLSearchParams(location.search);
        const clientSelected = JSON.parse(searchParams.get("client"));
        const missionSelected = JSON.parse(searchParams.get("missiondata"));
        const talentManagerSelected = JSON.parse(searchParams.get("talentManagerData"));
        setClientData((prevState) => ({
            ...prevState,
            value: clientSelected ?? showAllValue
        }))
        setMissionData((prevState) => (
            {
                ...prevState,
                value: missionSelected ?? showAllValue
            }))
        setTalentManagerData((prevState) => (
            {
                ...prevState,
                value: talentManagerSelected ?? showAllValue
            }))
        try {
            const search = `?${getInitialParameters()}`;
            loadReportingData();
            const response = await getAllCandidatsForReporting(search);
            setReportingData({
                isLoading: false,
                data: response.data.candidats
            });
        } catch (error) {
            snackbarShowMessage("Erreur de chargement des missions.", "error", 4000);
            setReportingData({
                isLoading: false,
                data: []
            });
        }
    };

    useEffect(() => {
        fetchReportingData();
    }, [query, reloadData, location.search]);


    const isSmMode = useMediaQuery(theme.breakpoints.between(0, 480));

    const handleAddCandidateInactiveOrActive = (isActive) => {
        if (location.search) {
            const urlParams = new URLSearchParams(location.search);
            urlParams.set('inactive', isActive);
            history.push(`/reporting/intern?${urlParams.toString()}`);
        }
    }

    
    const [clientType, setClientType] = useState('tous');
    const [filteredClients, setFilteredClients] = useState([]);
    const handleRadioChange = (event) => {
        const value = event.target.value;
        setClientType(value);
      
        if (value === 'tous') {
          setFilteredClients(clientData.data);
        } else {
          const filtered = clientData.data.filter(
            (item) => item.statut === value
          );
          setFilteredClients(filtered);
        }
      };
    
    let today = new Date();
    let dateExport = today.getDate() + "-" + (today.getMonth() + 1) + "-" + today.getFullYear();
    let fileName = dateExport;

    return (
        <Box sx={{ padding: "0 20px" }}>
            <Grid container spacing={1} style={{ paddingBottom: "20px" }}>
                <Grid item xs={10} sm={8} md={8} xl={6}>
                    <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
                        <h2 style={{ color: '#0f172a', fontFamily: "'Fira Sans', sans-serif", fontWeight: 700, fontSize: '1.35rem', margin: 0 }}>
                            Reporting — Process en cours
                        </h2>
                    </Box>
                </Grid>

                <Grid item xs={2} sm={4} md={4} xl={6} sx={{ display: "flex", justifyContent: "end", alignItems: "center", gap: "20px" }}>
                    <Box >
                        {!isSmMode ? <Button
                            startIcon={!query.inactive ? <Add /> : <Remove />}
                            className={classes.archiveButton}
                            onClick={(e) => {
                                setQuery({ inactive: !query.inactive });
                                handleAddCandidateInactiveOrActive(!query.inactive)
                            }}>
                            LES CANDIDATS INACTIFS
                        </Button>
                            : <IconButton data-toggle="tooltip"
                                title={!query.inactive ? "Ajouter" : "Retirer"} onClick={(e) => {
                                    setQuery({ inactive: !query.inactive });
                                    handleAddCandidateInactiveOrActive(!query.inactive);
                                }}>
                                {!query.inactive ? <Add /> : <Remove />}
                            </IconButton>
                        }
                    </Box>
                    <Box >
                        <DownloadXLSFile
                            csvData={reportingData.data}
                            fileName={fileName}
                            clientName={selectedClient}
                        />
                    </Box>
                </Grid>
            </Grid>
            
            <Box className="reporting_content">
                <Card elevation={0} sx={{ background: '#ffffff', borderRadius: '14px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,0.04), 0 4px 16px rgba(0,0,0,0.04)', mb: 2.5 }}>
                    <CardContent sx={{ p: '16px 24px !important', display: 'flex', alignItems: 'flex-end', gap: 3, flexWrap: 'wrap' }}>
                        {/* Filtrer clients */}
                        <Box sx={{ minWidth: 180 }}>
                            <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
                                Filtrer clients
                            </Typography>
                            <FormControl component="fieldset">
                                <RadioGroup row aria-label="client-type" name="clientType" value={clientType} onChange={handleRadioChange} sx={{ gap: 1 }}>
                                    <FormControlLabel value="tous" control={<Radio size="small" />} label="Tous" sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '1rem' } }} />
                                    <FormControlLabel value="client" control={<Radio size="small" />} label="Client" sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '1rem' } }} />
                                    <FormControlLabel value="prospect" control={<Radio size="small" />} label="Prospect" sx={{ m: 0, '& .MuiFormControlLabel-label': { fontSize: '1rem' } }} />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                        {[
                            { listData: { ...clientData, data: filteredClients }, handleChange: handleClientChange },
                            { listData: missionData, handleChange: handleMissionChange },
                            { listData: talentManagerData, handleChange: handleTalentManagerChange },
                        ].map((item, index) => (
                            <Box key={index} sx={{ flex: 1, minWidth: 200 }}>
                                <ReportingInternList listData={item.listData} handleDataChange={item.handleChange} />
                            </Box>
                        ))}
                    </CardContent>
                </Card>
                <Box className="reporting_container" >
                    <TableReportingIntern {...{ reloadData, setReloadData, reportingData, setReportingData }} />
                </Box>
            </Box>

        </Box>
    )
}

export default withSnackbar(ReportingIntern);